import styled from 'styled-components';

import { fontBold } from '../layout/font';

export const Price = styled.div`
  ${fontBold};
  font-size: 1.375rem;
`;

export const OldPrice = styled.div`
  color: var(--text-color-accent, ${(props) => props.theme.color.textDarkLighten});
  text-decoration: line-through;
`;
